exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".company-information-section .company-contact-margin {\n  margin-top: 0 !important;\n  margin-left: 0 !important;\n}\n.company-information-section .custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  color: #fff !important;\n  background-color: #6f7174 !important;\n  border-color: #6f7174 !important;\n}\n.custom-search-icon {\n  top: 2px;\n  right: 0;\n}\n.contact-result-section {\n  height: auto;\n  max-height: 250px;\n  overflow-y: auto;\n}\n.company-dropdown {\n  max-height: 200px;\n  overflow-y: auto;\n}\n", ""]);

// exports
